import React, {useState, useEffect, useCallback, useRef} from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {getBrands} from '../../../store/actions/dashboardAction'

//services/utils
import { useOrderDetails } from '../../../services/useOrderDetails';
import API from '../../../network/dashboardAPI';

//components
import DownloadInvoice from "../../../components/downloadInvoice";
import OrderItemTable from "./components/OrderItemTable";
import ResendPaymentOrder from '../../../components/resendPaymentOrder';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import UpdateAvailableDeliverySlotModal from "../../../components/UpdateAvailableDeliverySlot/UpdateAvailableDeliverySlotModal";
import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Table as MTable,
	LinearProgress,
	Paper,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography
} from "@material-ui/core";

// icons
import HistoryIcon from "@material-ui/icons/History"
import DescriptionIcon from '@material-ui/icons/Description';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';

import moment from "moment/moment";
//styles
import colors from "../../../theme/colors";
import { TableContent, HelpPageWrapper } from './styles';
import OrderCustomerTable from "./components/OrderCustomerTable";
import PickupPointCard from "./components/PickupPointCard";
import OrderDetailTable from "./components/OrderDetailTable";
import ShippingAndTrackingInfo from "./components/ShippingAndTrackingInfo";
import ToastNotification from "../../../components/ToastNotification/ToastNotification";
import DialogComponent from "../../../components/Modal/DialogComponent";
import OrderPaymentTable from "./components/OrderPaymentTable";
import AddPaymentMethodModal from "./components/AddPaymentMethodModal";
import AssignDriverDialog from "./components/AssignDriverDialog";
import FeedbackMessage from "../../../components/FeedbackMessage/FeedbackMessage";
import useAlert from "../../../services/useAlert";
import DeliPointsDialog from "./components/DeliPointsDialog";

const OrderDetails = (props) => {
	let admin = localStorage.getItem("admin");
	if(!admin) {
		window.location.href = "/";
	}
	const orderId = props.match.params.id;
	const [isShowCancelOrder, setIsShowCancelOrder] = useState(false);
	const [showToast, setShowToast] = useState(false);
	const [calculatedTotals, setCalculatedTotals] = useState(null);
	const [orderCouponDiscount, setOrderCouponDiscount] = useState(null);
	const [pendingAddress, setPendingAddress] = useState(null);
	const [forceHasChangesRef, setForceHasChangesRef] = useState(null);
	const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
	const [showPickupModal, setShowPickupModal] = useState(false);
	const [isSendingPickup, setIsSendingPickup] = useState(false);
	const [showDeliPointsDialog, setShowDeliPointsDialog] = useState(false);
	const history = useHistory();
	const alert = useAlert();
	const {state, setters, actions, utils, feedbackMessage} = useOrderDetails(orderId);

	// Will be initialized from details after load
	const [selectedCouponId, setSelectedCouponId] = useState(null);

	// Accessing state
	const {
		details,
		packageQuantity,
		packageWeight,
		extShippingCost,
		extPackingCost,
		extShippingCostCurrency,
		deliveryType,
		shipmentDetails,
		trackingEvent,
		trackingCode,
		courierCompanyList,
		courierCompany,
		slotHistoryModal,
		statusHistories,
		deliveredHistories,
		slotHistories,
		dialogLoading,
		modalType,
		getOrderId,
		deliveredAt,
		showUpdateSchedule,
		showDeleteTrackingCode,
		updatingSlot,
		selectedUpdateSlot,
		paymentModalOpen,
		paymentMethods,
		formPaymentMethod,
		paymentModalType,
		paymentType,
		deletePaymentModal,
		paymentReason,
		paymentTypeReason,
		refundReason,
		paymentNoteMethod,
		orderSummery,
		driverTip,
		deliveryFee,
		assignDriverModalOpen
	} = state;

	// Accessing setters
	const {
		setDetails,
		setGetOrderId,
		setShipmentDetail,
		setPackageQuantity,
		setPackageWeight,
		setExtShippingCost,
		setExtPackingCost,
		setExtShippingCostCurrency,
		setCourierCompany,
		setTrackingCode,
		setCourierCompanyList,
		setSlotHistoryModal,
		setStatusHistories,
		setDeliveredHistories,
		setSlotHistories,
		setDialogLoading,
		setModalType,
		setPaymentModalOpen,
		setFormPaymentMethod,
		setDeletePaymentModal,
		setPaymentNoteId,
		setPaymentReason,
		setShowDeleteTrackingCode,
		setDeliveryFee,
		setAssignDriverModalOpen
	} = setters;

	// Accessing actions
	const {
		fetchOrder,
		changeStatus,
		updateDeliveryType,
		getUpdateHistories,
		handleShowUpdateSchedule,
		handleCloseDeliverySlotModal,
		onUpdateSlotSelected,
		handleTrackingCode,
		createUpdateCourierCompany,
		handleSavePackage,
		getStatus,
		getAllCourierCompany,
		handleGoToCambodiaPost,
		handleOpenUpdateSlot,
		handleCloseUpdateSlot,
		toggleNewPaymentMethodModal,
		handleAddPaymentMethod,
		handleChangeMethod,
		storePaymentMethod,
		handleDeletePaymentMethod,
		calculatePaymentNote,
		calculateRemainingPayment,
		calculateDeliveryFee,
		calculateCouponDiscount,
		calculateWalletDiscount,
		calculateItemsTotal,
		calculateTotalToPayPayment,
		handleDeleteTrackingCode,
		handleDriverTipChange,
		handleDeliveryFeeChange,
		toggleAssignDriverModal,
		handleAssignDrivers
	} = actions;

	// Accessing utility getters
	const {
		storeItem,
		storeItemPrice,
		orderPayment,
		customer,
		address
	} = utils;


	const {
		feedback,
		closeFeedbackMessage
	} = feedbackMessage;

	// Ref to store recalculate handler for auto-recalculate on coupon/item changes
	const recalculateHandlerRef = useRef(null);
	const saveHandlerRef = useRef(null);
	const discardHandlerRef = useRef(null);
	const [showUnsavedModal, setShowUnsavedModal] = useState(false);
	const pendingNavigateRef = useRef(null);

	// Initialize selectedCouponId from order details when it loads
	useEffect(() => {
		if (details && details.coupon_code_id !== undefined) {
			setSelectedCouponId(details.coupon_code_id || null);
		}
	}, [details?.coupon_code_id]);

	// Initialize orderCouponDiscount from order details when it loads
	useEffect(() => {
		if (details) {
			// Check multiple sources for coupon discount with priority:
			// 1. order_payment_summery (from OrderBuilder)
			// 2. details.coupon_discount_amount (order-level field)
			// 3. details.coupon_discount (alternate field name)
			const summeryDiscount = parseFloat(details.order_payment_summery?.coupon_discount_amount) || 0;
			const detailsDiscount = parseFloat(details.coupon_discount_amount) || 0;
			const altDiscount = parseFloat(details.coupon_discount) || 0;

			const discount = summeryDiscount || detailsDiscount || altDiscount;

			setOrderCouponDiscount(discount);
		}
	}, [details?.order_payment_summery?.coupon_discount_amount, details?.coupon_discount_amount, details?.coupon_discount]);

	// Handle calculated totals from OrderItemTable
	const handleTotalsChange = useCallback((totals) => {
		setCalculatedTotals(totals);
		// Also update the delivery fee TextField value when recalculate returns a new delivery fee
		if (totals?.delivery_fee !== undefined && totals.delivery_fee !== null) {
			setDeliveryFee(totals.delivery_fee);
		}
	}, [setDeliveryFee]);

	// Handle orderSummery update from recalculate
	const handleOrderSummeryChange = useCallback((summery) => {
		// Update orderSummery state with recalculated values from API
		if (summery) {
			setters.setOrderSummery(prev => ({
				...prev,
				...summery
			}));

			// Also update details.total_kms if distance changed
			if (summery.total_kms !== undefined) {
				setters.setDetails(prev => ({
					...prev,
					total_kms: summery.total_kms
				}));
			}
		}
	}, [setters]);

	// Handle receiving forceHasChanges function from OrderItemTable
	const handleForceHasChanges = useCallback((forceFunc) => {
		setForceHasChangesRef(() => forceFunc);
	}, []);

	// Handle order-level coupon discount change (includes remove coupon)
	const handleOrderCouponDiscountChange = useCallback((value) => {
		setOrderCouponDiscount(value);
		// If removing coupon (value = 0), also clear the selected coupon ID
		if (value === 0) {
			setSelectedCouponId(null);
		}
	}, []);

	// Handle applying a coupon to the order (manual recalculate and save required)
	const handleApplyCoupon = useCallback((coupon) => {
		if (coupon && coupon.id) {
			// Store the coupon ID
			setSelectedCouponId(coupon.id);

			// Force hasChanges flag to enable Save button
			if (forceHasChangesRef) {
				forceHasChangesRef();
			}

			// Notify user to recalculate and save
			alert.toast(`Coupon "${coupon.code}" selected. Click "Recalculate" to distribute discount, then "Save" to apply changes.`, 'info');
		} else if (coupon === null) {
			// Remove coupon
			setSelectedCouponId(null);
			setOrderCouponDiscount(0);

			// Force hasChanges flag to enable Save button
			if (forceHasChangesRef) {
				forceHasChangesRef();
			}

			// Notify user to recalculate and save
			alert.toast('Coupon removed. Click "Recalculate" to update totals, then "Save" to apply changes.', 'info');
		}
	}, [alert, forceHasChangesRef]);

	const handleShowCancelOrder = () => {
		setIsShowCancelOrder(prev => !prev);
	}

	const handleSubmitCancelOrder = () => {
		changeStatus(7);
		handleShowCancelOrder();
		setShowToast(prev => !prev);

		setTimeout(() => {
			history.push('/admin/orders')
		}, 1750)
	}

	const renderSlotTimeButtonOrText = (details, handleShowUpdateSchedule) => {
		const slot = details.store_on_going_slots?.[0] || details.store_on_going_slot;
		if (!slot) return null;

		let displayText = '';
		const slotType = details.slot_type;

		if (slotType === "hourly") {
			displayText = moment(slot.start_time).format("YYYY/MM/DD h:mm a");
		} else if (slotType === "medium") {
			displayText = `${moment(slot.Date).format("YYYY/MM/DD")} ${moment(slot.start_time).format("h:mm a")} - ${moment(slot.end_time).format("h:mm a")}`;
		} else if (slotType === "large") {
			displayText = `Any time at ${moment(slot.Date).format("YYYY/MM/DD")}`;
		}

		if ([2, 3, 4, 5, 6, 8].includes(details.status)) {
			return (
				<Button
					onClick={() => handleShowUpdateSchedule(details.order_id, details.delivered_at)}
					variant="contained"
					color={"primary"}
				>
					{displayText}
				</Button>
			);
		}

		return <p>{displayText}</p>;
	};

	const statusMap = {
		2: { label: "New", color: "#ED9704" },
		3: { label: "Accepted", color: "#F30A0B" },
		4: { label: "Packed", color: "#4D4C5C" },
		5: { label: "On the way", color: "#56E76F" },
		6: { label: "Delivered", color: "#49A641" },
		7: { label: "Cancelled", color: "#A10559" },
		8: { label: "Arrived", color: "#7E481C" },
	};

	const renderStatusButton = (value) => {
		const status = statusMap[value];
		if (!status) return null;
		return (
			<Button
				variant="success"
				style={{
					backgroundColor: status.color,
					width: "12vh",
					border: "none",
					cursor: "auto",
					outline: "none",
					boxShadow: "none",
					color: "#ffffff",
				}}
			>
				{status.label}
			</Button>
		);
	};

	const renderRow = (row) => (
		<TableRow hover key={row.id || row.order_id}>
			<TableCell>{row.order_id}</TableCell>
			<TableCell>{row.field}</TableCell>
			<TableCell>
				{row.field === "order_status" ? renderStatusButton(row.value_new) :
					row.field === 'timeslot_start_time' ? row.value_new ? moment(row.value_new).format("DD/MMM/YY - hh:mm A") : "-" : row.value_new}
			</TableCell>
			<TableCell>
				{row.field === "order_status" ? renderStatusButton(row.value_old) :
					row.field === 'timeslot_start_time' ? row.value_old ? moment(row.value_old).format("DD/MMM/YY - hh:mm A") : "-" : row.value_old}
			</TableCell>
			<TableCell>
				{row.store_user?.first_name} {row.store_user?.last_name}
			</TableCell>
			<TableCell>
				{moment(row.createdAt).format("DD/MMM/YY - hh:mm A")}
			</TableCell>
		</TableRow>
	);

	const histories = {
		order_status: statusHistories,
		delivered_at: deliveredHistories,
		timeslot_start_time: slotHistories,
		timeslot_full_day: slotHistories,
	};

	useEffect(async () => {
		await fetchOrder();
		setFormPaymentMethod({
			...formPaymentMethod,
			order_id: orderId,
		})
	}, []);

	useEffect(async() => {
		await getAllCourierCompany();
	}, []);

	// Warn on browser reload / tab close when there are unsaved changes
	useEffect(() => {
		const onBeforeUnload = (e) => {
			if (hasUnsavedChanges) {
				e.preventDefault();
				e.returnValue = '';
			}
		};
		window.addEventListener('beforeunload', onBeforeUnload);
		return () => window.removeEventListener('beforeunload', onBeforeUnload);
	}, [hasUnsavedChanges]);

	// Block in-app navigation while unsaved changes exist; show confirmation modal
	useEffect(() => {
		if (!hasUnsavedChanges) {
			// Block just cleared — if the modal left a pending location, navigate now
			if (pendingNavigateRef.current) {
				const loc = pendingNavigateRef.current;
				pendingNavigateRef.current = null;
				history.push(loc);
			}
			return;
		}
		const unblock = history.block((location) => {
			pendingNavigateRef.current = location;
			setShowUnsavedModal(true);
			return false;
		});
		return () => unblock();
	}, [hasUnsavedChanges, history]);

	// Modal: user chose "Cancel" — stay on the page
	const handleModalCancel = useCallback(() => {
		setShowUnsavedModal(false);
		pendingNavigateRef.current = null;
	}, []);

	// Modal: user chose "Discard" — drop local edits; navigate fires when block clears
	const handleModalDiscard = useCallback(async () => {
		setShowUnsavedModal(false);
		if (discardHandlerRef.current) {
			await discardHandlerRef.current();
		}
	}, []);

	// Modal: user chose "Save" — persist changes; navigate fires when block clears
	const handleModalSave = useCallback(async () => {
		setShowUnsavedModal(false);
		if (saveHandlerRef.current) {
			await saveHandlerRef.current();
		}
	}, []);

	// Guard: block if unsaved changes exist (same behaviour as Resend Order)
	const handleOpenPickupModal = () => {
		if (hasUnsavedChanges) {
			alert.toast('Please save your changes first', 'warning');
			const saveBtn = document.getElementById('order-save-btn');
			if (saveBtn) saveBtn.scrollIntoView({behavior: 'smooth', block: 'center'});
			return;
		}
		setShowPickupModal(true);
	};

	// Send pickup file for this single order
	const handleSendPickup = async () => {
		setIsSendingPickup(true);
		try {
			await API.createPickupFile({order_ids: String(orderId)});
			alert.toast('Generating pickup file and Sending', 'success');
		} catch (error) {
			alert.toast('Failed to send pickup file', 'error');
		} finally {
			setIsSendingPickup(false);
			setShowPickupModal(false);
		}
	};

	return (
		details &&
		<HelpPageWrapper>
			<h4 className="mb-3 d-flex align-items-center justify-content-between">
				<Typography variant='h5' className={"text-uppercase font-weight-bold mb-1"}><DescriptionIcon style={{color: colors.primary, fontSize: "2rem"}}/> Order Details (#{orderId})</Typography>
				<div className="pull-right" style={{ display: "flex", gap: 10 }}>
					<DownloadInvoice orderId={orderId} />
					<Button variant="contained" size="small" startIcon={<LocalShippingIcon/>}
					        style={{backgroundColor: '#f44336', color: '#fff'}}
					        onClick={handleOpenPickupModal}>
						Send Pickup File
					</Button>
					<ResendPaymentOrder orderId={orderId} hasUnsavedChanges={hasUnsavedChanges}/>
				</div>
			</h4>
			<Row>
				{/*OrderDetailTable*/}
				<Col className={"pb-3"} md={12} xl={6}>
					<Row>
						<Col>
							<OrderDetailTable
								details={details}
								colors={colors}
								courierCompany={courierCompany}
								setCourierCompany={setCourierCompany}
								courierCompanyList={courierCompanyList}
								createUpdateCourierCompany={createUpdateCourierCompany}
								deliveryType={deliveryType}
								getStatus={getStatus}
								orderPayment={orderPayment}
								handleOpenUpdateSlot={handleOpenUpdateSlot}
								handleShowUpdateSchedule={handleShowUpdateSchedule}
								updateDeliveryType={updateDeliveryType}
								renderSlotTimeButtonOrText={renderSlotTimeButtonOrText}
								handleTrackingCode={handleTrackingCode}
								trackingCode={trackingCode}
								setTrackingCode={setTrackingCode}
								setShowDeleteCode={setShowDeleteTrackingCode}
								trackingEvent={trackingEvent}
								deliveryFee={deliveryFee}
								onDeliveryFeeChange={handleDeliveryFeeChange}
								calculatedTotals={calculatedTotals}
								orderCouponDiscount={orderCouponDiscount}
								onOrderCouponDiscountChange={handleOrderCouponDiscountChange}
								onApplyCoupon={handleApplyCoupon}
								onAssignDriverClick={toggleAssignDriverModal}
								onDeliPointsClick={() => setShowDeliPointsDialog(true)}
							/>
						</Col>
					</Row>
					<Row className={"mt-2"}>
						<Col>
							<OrderPaymentTable
								details={details}
								onAddPaymentClick={toggleNewPaymentMethodModal}
								onDeliPointsClick={() => setShowDeliPointsDialog(true)}
								dialogLoading={dialogLoading} setDeletePaymentModal={setDeletePaymentModal}
								setPaymentNoteId={setPaymentNoteId}
								orderPayment={orderPayment}
								paymentNoteMethod={paymentNoteMethod}
								calculatePaymentNote={calculatePaymentNote}
								calculateRemainingPayment={calculateRemainingPayment}
								calculateDeliveryFee={calculateDeliveryFee}
								calculateCouponDiscount={calculateCouponDiscount}
								calculateWalletDiscount={calculateWalletDiscount}
								calculateItemsTotal={calculateItemsTotal}
								calculateTotalToPayPayment={calculateTotalToPayPayment}
								orderSummery={orderSummery}
								driverTip={driverTip}
								onDriverTipChange={handleDriverTipChange}
								calculatedTotals={calculatedTotals}
								deliveryFee={deliveryFee}
								orderCouponDiscount={orderCouponDiscount}
							/>
							<AddPaymentMethodModal
								onAdd={toggleNewPaymentMethodModal}
								onClose={toggleNewPaymentMethodModal}
								open={paymentModalOpen}
								handleChangeMethod={handleChangeMethod}
								paymentMethods={paymentMethods}
								handleAddPaymentMethod={handleAddPaymentMethod}
								formPaymentMethod={formPaymentMethod}
								paymentModalType={paymentModalType}
								storePaymentMethod={storePaymentMethod}
								paymentType={paymentType}
								dialogLoading={dialogLoading}
								paymentReason={paymentReason}
								refundReason={refundReason}
									paymentTypeReason={paymentTypeReason}
									setFormPaymentMethod={setFormPaymentMethod}
									orderId={orderId}
								/>
						</Col>
					</Row>
				</Col>
				<Col md={12} xl={6}>
					<Row>
						{/*OrderCustomerTable*/}
						<Col>
							<OrderCustomerTable
								details={details}
								customer={customer}
								address={address}
								pendingAddress={pendingAddress}
								onAddressChanged={(newAddress) => setPendingAddress(newAddress)}
							/>
						</Col>
					</Row>
					<Row>
						{/*Pickup point details + map (only when the order has one)*/}
						<Col>
							<PickupPointCard details={details} onUpdated={fetchOrder}
								hasUnsavedChanges={hasUnsavedChanges || Boolean(pendingAddress)}/>
						</Col>
					</Row>
					<Row>
						{/*shipping And Tracking Infos*/}
						<Col>
							{(details.status > 2 && details.status !== 7 && details.external_courier === 0 ) &&
								<ShippingAndTrackingInfo
									details={details}
									trackingEvent={trackingEvent}
									trackingCode={trackingCode}
									setTrackingCode={setTrackingCode}
									handleTrackingCode={handleTrackingCode}
									courierCompany={courierCompany}
									setCourierCompany={setCourierCompany}
									courierCompanyList={courierCompanyList}
									packageQuantity={packageQuantity}
									setPackageQuantity={setPackageQuantity}
									packageWeight={packageWeight}
									setPackageWeight={setPackageWeight}
									extShippingCost={extShippingCost}
									setExtShippingCost={setExtShippingCost}
									extPackingCost={extPackingCost}
									setExtPackingCost={setExtPackingCost}
									extShippingCostCurrency={extShippingCostCurrency}
									setExtShippingCostCurrency={setExtShippingCostCurrency}
									handleSavePackage={handleSavePackage}
									handleGoToCambodiaPost={handleGoToCambodiaPost}
									dialogLoading={dialogLoading}
									colors={colors}
								/>
							}
						</Col>
					</Row>
				</Col>
			</Row>
			<Row>
				{/*OrderItemTable*/}
				<Col>
					<OrderItemTable details={details} storeItem={storeItem} storeItemPrice={storeItemPrice}
					                orderPayment={orderPayment} colors={colors}
					                driverTip={driverTip}
					                onDriverTipChange={handleDriverTipChange}
					                deliveryFee={deliveryFee}
					                onDeliveryFeeChange={handleDeliveryFeeChange} refreshOrder={fetchOrder}
					                onTotalsChange={handleTotalsChange}
					                onOrderSummeryChange={handleOrderSummeryChange}
					                orderCouponDiscount={orderCouponDiscount}
					                onOrderCouponDiscountChange={handleOrderCouponDiscountChange}
					                selectedCouponId={selectedCouponId}
					                calculatedTotals={calculatedTotals}
					                pendingAddress={pendingAddress}
					                onAddressSaved={() => setPendingAddress(null)}
					                onForceHasChanges={handleForceHasChanges}
					                onHasChangesChange={setHasUnsavedChanges}
					                recalculateHandlerRef={recalculateHandlerRef}
					                saveHandlerRef={saveHandlerRef}
					                discardHandlerRef={discardHandlerRef}/>
				</Col>
			</Row>

			{/*cancel order modal*/}
			<DialogComponent
				open={isShowCancelOrder}
				onClose={handleShowCancelOrder}
				title={"Warning"}
				description={"Do you want to cancel the order?"}
				buttonLabel={"Close"}
				confirmLabel={"Ok"}
				onConfirm={handleSubmitCancelOrder}
				showConfirmButton={true}
				buttonColor={"red"}
				confirmColor={"#9cc54b"}
			/>

			<DialogComponent
				open={showDeleteTrackingCode}
				onClose={() => setShowDeleteTrackingCode(false)}
				title={"Warning"}
				description={"Do you want to delete the shipment tracking?"}
				buttonLabel={"Close"}
				confirmLabel={"Ok"}
				onConfirm={() => handleDeleteTrackingCode(trackingCode)}
				showConfirmButton={true}
				buttonColor={"red"}
				confirmColor={"#9cc54b"}
			/>

			<DialogComponent
				open={deletePaymentModal}
				onClose={() => setDeletePaymentModal(false)}
				title={"Warning"}
				description={"Do you want to delete this payment note?"}
				buttonLabel={"Close"}
				confirmLabel={"confirm"}
				onConfirm={handleDeletePaymentMethod}
				showConfirmButton={true}
				buttonColor={"red"}
				confirmColor={"#ffffff"}
				confirmVariant={"contained"}
				confirmBackground={"#9cc54b"}
			/>
			{/*update delivery modal*/}
			{showUpdateSchedule && <UpdateAvailableDeliverySlotModal
				show={showUpdateSchedule}
				handleCloseDialog={handleCloseDeliverySlotModal}
				selectedSlot={selectedUpdateSlot}
				onSlotSelected={onUpdateSlotSelected}
				pageName="admin-orders"
				orderId={getOrderId}
				slotId={details?.slot_id}
				order={details}
				updatingSlot={updatingSlot}
			/>}

			{/*Order status histories*/}
			<DialogComponent
				open={slotHistoryModal}
				onClose={() => handleCloseUpdateSlot(false)}
				title="Update Histories"
				IconComponent={HistoryIcon}
				buttonLabel="Close"
				buttonColor="#000"
				maxWidth="lg"
				fullWidth
			>
				<TableContent>
					<Paper>
						<TableContainer style={{ maxHeight: window.innerHeight - 280 }}>
							<MTable stickyHeader>
								<TableHead>
									<TableRow>
										<TableCell>Order ID</TableCell>
										<TableCell>Field</TableCell>
										<TableCell>Value New</TableCell>
										<TableCell>Value Old</TableCell>
										<TableCell>User Name</TableCell>
										<TableCell>Modified at</TableCell>
									</TableRow>
								</TableHead>

								{modalType && (
									<TableBody>
										{histories[modalType]?.length > 0 ? (
											histories[modalType].map(renderRow)
										) : (
											<TableRow>
												<TableCell align="center" colSpan={8}>
													No Data
												</TableCell>
											</TableRow>
										)}
									</TableBody>
								)}
							</MTable>
						</TableContainer>

						{dialogLoading && <LinearProgress variant="query" />}
					</Paper>
				</TableContent>
			</DialogComponent>

			{/*toast cancel order*/}
			<ToastNotification toastBgColor={"bg-success"} toastMessage={"The order is cancelled!"} showToast={showToast}/>
			{feedback &&
				<FeedbackMessage open={feedback && feedback} onClose={closeFeedbackMessage} variant={feedback.variant}
				                 description={feedback.description} title={feedback.title}/>}

			{/* Send Pickup File confirmation modal */}
			<Dialog open={showPickupModal} onClose={() => setShowPickupModal(false)}>
				<DialogTitle>Send Pickup File</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Do you want to send pickup file for order #{orderId}?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button disabled={isSendingPickup} onClick={() => setShowPickupModal(false)} style={{color: '#666'}}>
						Close
					</Button>
					<Button disabled={isSendingPickup} variant="contained" onClick={handleSendPickup}
					        style={{backgroundColor: '#f44336', color: '#fff'}}>
						{isSendingPickup && <CircularProgress size={16} style={{marginRight: 6, color: '#fff'}}/>}
						Send
					</Button>
				</DialogActions>
			</Dialog>

			{/* Unsaved changes guard modal (in-app navigation) */}
			<Dialog open={showUnsavedModal} onClose={handleModalCancel}>
				<DialogTitle>Unsaved Changes</DialogTitle>
				<DialogContent>
					<DialogContentText>
						You have unsaved changes. What would you like to do?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleModalCancel} style={{color: '#666'}}>Cancel</Button>
					<Button onClick={handleModalDiscard} style={{color: '#f44336'}}>Discard</Button>
					<Button onClick={handleModalSave} variant="contained"
					        style={{backgroundColor: '#9cc54b', color: '#fff'}}>Save</Button>
				</DialogActions>
			</Dialog>

			{/* Assign Driver Dialog */}
			{details && (
				<AssignDriverDialog
					open={assignDriverModalOpen}
					onClose={toggleAssignDriverModal}
					order={details}
					onAssign={handleAssignDrivers}
					colors={colors}
				/>
			)}

		{/* DeliPoints Dialog */}
			{details && (
				<DeliPointsDialog
					open={showDeliPointsDialog}
					onClose={() => setShowDeliPointsDialog(false)}
					details={details}
					orderId={orderId}
				/>
			)}

		</HelpPageWrapper>
	);
}
const mapStateToProps = state =>{
	return {
		brands : state.dashboardReducer.brands
	}

}

const mapDispatchToProps = dispatch => {
	return {
		getBrands : data => getBrands(data,dispatch)
	}
}
export default connect(mapStateToProps,mapDispatchToProps)(OrderDetails)
